import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconInternet: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.3 3.3c.4.4.4 1 0 1.4-3.1 3.1-3.1 8.2 0 11.3.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3C1 13.5 1 7.2 4.9 3.3c.4-.4 1-.4 1.4 0zm12.7 0c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4 3.1 3.1 3.1 8.2 0 11.3-.4.4-.4 1 0 1.4.2.2.5.3.7.3.2 0 .5-.1.7-.3 3.9-3.9 3.9-10.2 0-14.1zM7.6 6C8 5.6 8.7 5.6 9 6c.4.4.4 1 0 1.4-1.6 1.6-1.6 4.3 0 5.9.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3-2.4-2.4-2.4-6.3 0-8.7zm8.7 0c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4 1.6 1.6 1.6 4.2 0 5.9-.4.4-.4 1 0 1.4.2.2.5.3.7.3.2 0 .5-.1.7-.3 2.4-2.4 2.4-6.3 0-8.7zM12 8c-1.1 0-2 .9-2 2 0 .7.4 1.4 1 1.7V20c0 .6.4 1 1 1s1-.4 1-1v-8.3c.6-.3 1-1 1-1.7 0-1.1-.9-2-2-2z',
    })
  )
}
